import EntityModel from '@/common/models/entity-model';
import RuleActionModel from '@/common/models/rules/actions/rule-action-model';

export class WebhookHeaderModel extends EntityModel {
    hydrate({
        name = null,
        value = null,
        status = null,
    } = {}) {
        this.name = name;
        this.value = value;
        this.status = WebhookHeaderModel.convertStringStatus(status);
    }

    get isActive() {
        return this.status === WebhookHeaderModel.ToggleStatuses.active.value;
    }

    getPayload() {
        return {
            name: this.name,
            value: this.value,
            status: WebhookHeaderModel.convertBooleanStatus(this.status),
        };
    }
}

export default class TriggerWebhookActionModel extends RuleActionModel {
    hydrate(fields) {
        super.hydrate(fields);
        const {
            method = null,
            url = null,
            body = null,
            credentialHash = null,
            query = {},
            headers = [],
        } = fields;
        this.credentialHash = credentialHash;
        this.method = method;
        this.url = url;
        this.body = body;
        this.query = query;
        this.headers = headers.map(header => new WebhookHeaderModel(header));
    }

    static Methods = {
        get: 'get',
        post: 'post',
        put: 'put',
        patch: 'patch',
        delete: 'delete',
    };

    getPayload() {
        return {
            ...super.getPayload(),
            credentialHash: this.credentialHash,
            method: this.method,
            url: this.url,
            body: this.body,
            query: this.query,
            headers: this.headers.map(header => header.getPayload()),
        };
    }
}
